import{Signal as t}from"signal-polyfill";export*from"signal-polyfill";export{SignalWatcher}from"./lib/signal-watcher.js";export{WatchDirective,watch}from"./lib/watch.js";export{html,svg,withWatch}from"./lib/html-tag.js";
/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */const l=t.State,o=t.Computed,r=(l,o)=>new t.State(l,o),i=(l,o)=>new t.Computed(l,o);export{o as Computed,l as State,i as computed,r as signal};
//# sourceMappingURL=index.js.map
